import {observer} from "mobx-react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Link,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {LoadingButton} from "@mui/lab"
import ContactMap from "./ContactMap/ContactMap";
import React from "react";
import {useStore} from "../../stores/Store";
import ContactAreasOfInterest from "./ContactAreasOfInterest";
import ContactInformationForm from "./ContactInformationForm";
import {useReCaptcha} from "../../hooks/useRecaptcha";
import {renderText} from "../../assets/languageMessages/languageMessageUtils";

interface Props {
    showAreasOfInterest?: boolean,
    showMap?: boolean
}

export default observer(function ContactPage({showAreasOfInterest = true, showMap = true}: Props){
    const {LanguageStore, ContactFormStore} = useStore();
    const {currentLanguageMessages, currentLanguage} = LanguageStore;
    const { sendForm, isLoading } = ContactFormStore;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const verifyCaptcha = useReCaptcha();

    const onClick = async () => {
        const token = await verifyCaptcha('contact_form');
        if(token) sendForm(currentLanguage, token);
    }

    return (
        <Box sx={{display: 'flex', rowDirection: 'column', width: '100%', justifyContent: 'center', marginBottom: '16px'}}>
            <Card elevation={0} sx={(isSmallScreen) ? null : {width: '80%'}}>
                {
                    (showMap) &&
                        <CardMedia>
                            <ContactMap />
                        </CardMedia>
                }
                <CardContent>
                    <Typography variant={'h5'}>
                        { currentLanguageMessages.ContactPage.ContactUsCardTitle }
                    </Typography>
                    <Typography>{renderText(currentLanguageMessages.ContactPage.ContactUsCardDescription)}</Typography>
                    { showAreasOfInterest && <ContactAreasOfInterest /> }
                    <ContactInformationForm />
                </CardContent>
                <CardActions sx={{justifyContent: 'center'}}>
                    <LoadingButton
                        sx={{width: 400}}
                        variant={'contained'}
                        onClick={onClick}
                        loading={isLoading}
                    >
                        { currentLanguageMessages.ContactPage.contactInformation.sendButtonLabel }
                    </LoadingButton>
                </CardActions>
            </Card>
        </Box>
    )
})